import { rem } from "polished";
import { ThemeKind } from "src/types";
import styled from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/colors";

export const VideoGridContainer = withViewportStyle("div")`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 0 auto;
  justify-content: center;
  align-items: center;

  & > [data-video-item] {
    flex: 1 1 calc(25% - 1rem);
    max-width: calc(25% - 1rem);
  }

  ${(props) => props.$viewport.tablet`
    & > [data-video-item] { 
      flex-basis: calc(50% - 1rem);
      max-width: calc(50% - 1rem);
    }
  `}

  ${(props) => props.$viewport.mobile`
    & > [data-video-item] {    
      flex-basis: 100%;
      max-width: 100%;
    }
  `}
`;

export const StyledFlex = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${rem(40)};

  .text-primitive {
    color: ${({ theme }) => {
      const colorKey =
        theme.themeKind === `${ThemeKind.NOLAN}`
          ? ColorLabels.PRIMARY_FONT
          : ColorLabels.SECONDARY_FONT;

      return theme.colors[colorKey];
    }};
  }
`;

export const BlockPadding = styled.div`
  padding: ${rem(24)};
`;

export const EmptyBlockMessage = styled.p`
  display: block;
  align-items: center;
  text-align: center;
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  gap: ${rem(16)};
  padding: ${rem(16)} 0;
  color: ${({ theme }) => {
    const colorKey =
      theme.themeKind === `${ThemeKind.NOLAN}`
        ? ColorLabels.PRIMARY_FONT
        : ColorLabels.SECONDARY_FONT;

    return theme.colors[colorKey];
  }};
`;
